import o from "./highrise1528.mjs";
import r from "./highrise1310.mjs";
var m = o(r, "Promise");
export {
  m as default
};
